import { Network } from '@/utils/network'
import urls from './urls.json'

async function connectWithOtp(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(data) {
  const url = urls.connectWithOtp
  const reqData = {
    firstName: "Nouvel Utilisateur",
    lastName: "Non enrégistré",
    phoneNumber: "00000000000000",
    email: data.email,
    otp: data.otp,
    countryCode: data.countryCode,
    token: data.token,
    metadata: {},
  }
  const response = await Network.sendPostRequest(url, reqData)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawUser = response.response.user
    const user = {
      firstName: rawUser.firstName,
      lastName: rawUser.lastName,
      metadata: rawUser.metadata,
      phoneNumber: rawUser.phoneNumber,
      email: rawUser.email,
      id: rawUser.id,
    }

    return {
      success: true,
      user,
    }
  }
  if (response.status.code === 404) {
    return {
      success: false,
      userNotFound: true,
      messageId: 'messages.connectWithOtp.userNotFound',
    }
  }
  if (response.status.code === 401) {
    return {
      success: false,
      badPassword: true,
      messageId: 'messages.connectWithOtp.badPassword',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { connectWithOtp }
